import { EmailTemplate } from './email-template';

export class TemplateLink {

    constructor(
        public emailTemplate: EmailTemplate | null,
        public url: string,
        public text: string,
        public id?: number | null
    ){}
}
